import { render, staticRenderFns } from "./EditSettings.vue?vue&type=template&id=a1ff5ba8&"
import script from "./EditSettings.vue?vue&type=script&lang=ts&"
export * from "./EditSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports